module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"challenge":"Challenge","opportunity":"Opportunity"},"en":{"challenge":"Challenge","opportunity":"Opportunity"}}')
  delete Component.options._Ctor
}
